// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__Em2Y0","notification__text":"Notification_notification__text__JAIYZ"};